import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Home from './pages/Home';
import WildlifeSanctuaries from './pages/WildlifeSanctuaries';
import Trekking from './pages/Trekking';
import Stories from './pages/Stories';
import Contact from './pages/Contact';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import BookSafari from './pages/BookSafari';
import BookTrek from './pages/BookTrek';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PageTransition from './components/PageTransition';
import './i18n';
import './index.css';

function AppRoutes() {
  const location = useLocation();
  return (
    <PageTransition key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/wildlife" element={<WildlifeSanctuaries />} />
        <Route path="/trekking" element={<Trekking />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/book-safari" element={<BookSafari />} />
        <Route path="/book-trek" element={<BookTrek />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </PageTransition>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Toaster position="top-right" />
      <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <div style={{ flex: 1 }}>
          <AppRoutes />
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
